import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";
const AlertsModal = ({
  show,
  onClose,
  alertText,
  onNext,
}: {
  show: boolean;
  onClose: () => void;
  alertText: string;
  onNext: () => void;
}) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg p-6 w-96 relative">
        <button
          className="absolute top-2 right-3 text-xl font-bold text-[#1F2937] text-[32px]"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <div className="flex items-center mb-4">
          <span className="text-orange-500 mr-2 text-md text-[20px]">
            <FaExclamationTriangle />
          </span>

          <h3 className="text-[28px] font-medium text-[#1e2b5e] font-georgia leading-[32px] tracking-[0px] vertical-align-middle">
            Alert
          </h3>
        </div>
        <p className="text-[16px] text-[#1B365D] mb-2 leading-[24px] tracking-[0%] vertical-align-middle">{alertText}</p>
        <button
          className="w-full bg-[#F4A261] text-[#1B365D] font-semibold p-3 rounded-[50px] text-base hover:bg-[#F29449] mt-2"
          onClick={onNext}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AlertsModal;
